import { Injectable } from '@angular/core';
import { from, map } from 'rxjs';
import { assign, cloneDeep } from 'lodash-es';
import { FuseMockApiService, FuseMockApiUtils } from '@fuse/lib/mock-api';
import { meetings as meetingsData } from './data';


@Injectable({
    providedIn: 'root'
})
export class MeetingsMockApi
{
    private _meetings: any[] = meetingsData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods 
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Subscription - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/meetings/all')
            .reply(() => {

                // Clone the subscriptions
                const subscriptions = cloneDeep(this._meetings);

                // Sort the subscriptions by the name field by default
                // subscriptions.sort((a, b) => a.name.localeCompare(b.name));

                // Return the response
                return [200, subscriptions];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Subscription Search - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/meetings/search')
            .reply(({request}) => {

                // Get the search query
                const query = request.params.get('query');

                // Clone the subscriptions
                let subscriptions = cloneDeep(this._meetings);

                // If the query exists...
                if ( query )
                {
                    // Filter the subscriptions
                    subscriptions = subscriptions.filter(subscription => subscription.subject && subscription.subject.toLowerCase().includes(query.toLowerCase()));
                }

                // Sort the subscriptions by the name field by default
                // subscriptions.sort((a, b) => a.name.localeCompare(b.name));

                // Return the response
                return [200, subscriptions];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/apps/meetings/meeting')
            .reply(({request}) => {

                // Get the id from the params
                const id = request.params.get('id');

                // Clone the subscriptions
                const subscriptions = cloneDeep(this._meetings);

                // Find the subscription
                const subscription = subscriptions.find(item => item.id === id);

                // Return the response
                return [200, subscription];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - POST
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPost('api/apps/meetings/meeting')
            .reply(() => {

                // Generate a new meeting
                const newContact = {
                    id          : FuseMockApiUtils.guid(),
                    avatar      : null,
                    name        : 'New Contact',
                    emails      : [],
                    phoneNumbers: [],
                    job         : {
                        title  : '',
                        company: ''
                    },
                    birthday    : null,
                    address     : null,
                    notes       : null,
                    tags        : []
                };

                // Unshift the new subscription
                this._meetings.unshift(newContact);

                // Return the response
                return [200, newContact];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - PATCH
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPatch('api/apps/meetings/meeting')
            .reply(({request}) => {

                // Get the id and subscription
                const id = request.body.id;
                const subscription = cloneDeep(request.body.subscription);

                // Prepare the updated subscription
                let updatedContact = null;

                // Find the subscription and update it
                this._meetings.forEach((item, index, subscriptions) => {

                    if ( item.id === id )
                    {
                        // Update the subscription
                        subscriptions[index] = assign({}, subscriptions[index], subscription);

                        // Store the updated subscription
                        updatedContact = subscriptions[index];
                    }
                });

                // Return the response
                return [200, updatedContact];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ Contact - DELETE
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onDelete('api/apps/meetings/meeting')
            .reply(({request}) => {

                // Get the id
                const id = request.params.get('id');

                // Find the subscription and delete it
                this._meetings.forEach((item, index) => {

                    if ( item.id === id )
                    {
                        this._meetings.splice(index, 1);
                    }
                });

                // Return the response
                return [200, true];
            });
    }
}
